/**
 * Token迁移工具
 * 用于从SSO的cookie中获取token并迁移到localStorage
 */
class TokenMigrator {
  /**
   * 从cookie中获取token
   * @param {string} name cookie名称
   * @returns {string|null} token值
   */
  static getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  /**
   * 获取所有可能的SSO token cookie
   * @returns {Object} 包含所有找到的token
   */
  static getAllSSOTokens() {
    const possibleNames = [
      'katoken',
      'token',
      'access_token',
      'auth_token',
      'session_token',
      'sso_token',
      'jwt_token',
      'bearer_token'
    ];

    const tokens = {};
    possibleNames.forEach(name => {
      const value = this.getCookie(name);
      if (value) {
        tokens[name] = value;
      }
    });

    return tokens;
  }

  /**
   * 迁移token到localStorage
   * @param {string} localStorageKey localStorage的key
   * @param {boolean} removeCookie 是否删除cookie中的token
   * @returns {string|null} 迁移的token
   */
  static migrateToLocalStorage(localStorageKey = 'katoken', removeCookie = false) {
    const tokens = this.getAllSSOTokens();
    
    if (Object.keys(tokens).length === 0) {
      console.log('未找到任何SSO token cookie');
      return null;
    }

    // 优先使用katoken，其次是其他token
    let tokenToMigrate = null;
    let cookieName = null;

    if (tokens.katoken) {
      tokenToMigrate = tokens.katoken;
      cookieName = 'katoken';
    } else {
      // 使用第一个找到的token
      cookieName = Object.keys(tokens)[0];
      tokenToMigrate = tokens[cookieName];
    }

    if (tokenToMigrate) {
      // 存储到localStorage
      localStorage.setItem(localStorageKey, tokenToMigrate);
      console.log(`成功迁移token从cookie '${cookieName}' 到localStorage '${localStorageKey}'`);

      // 可选：删除cookie中的token
      if (removeCookie) {
        this.removeCookie(cookieName);
        console.log(`已删除cookie '${cookieName}'`);
      }

      return tokenToMigrate;
    }

    return null;
  }

  /**
   * 删除cookie
   * @param {string} name cookie名称
   */
  static removeCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  /**
   * 检查是否有可迁移的token
   * @returns {boolean} 是否有可迁移的token
   */
  static hasMigratableTokens() {
    const tokens = this.getAllSSOTokens();
    return Object.keys(tokens).length > 0;
  }

  /**
   * 调试：显示所有cookie信息
   */
  static debugCookies() {
    console.log('=== Cookie调试信息 ===');
    console.log('所有cookie:', document.cookie);
    
    const tokens = this.getAllSSOTokens();
    console.log('找到的SSO tokens:', tokens);
    
    const localStorageToken = localStorage.getItem('katoken');
    console.log('localStorage中的token:', localStorageToken ? '存在' : '不存在');
    
    console.log('=== 调试信息结束 ===');
  }
}

export default TokenMigrator; 